import { css } from 'lit';

export const resetCss = css`
  * {
    margin: 0;
    padding: 0;
  }
`;
